import { I18n } from '@/services/i18n';

type Message = {
  beginYourJourney: string;
  welcome: string;
  continuePerWeek: string;
  meetNewNicePeopleOnline: string;
  next: string;
  free: string;
  rightNowYouAreOn: string;
  freeSubscription: string;
  trial: string;
  premium: string;
  seeBasicProfilesOfOtherSingles: string;
  titleFreeSubscription: string;
  limitedChatting: string;
  limitedLikes: string;
  seeFullProfilesOfOtherSingles: string;
  unlimitedChatting: string;
  unlimitedLikes: string;
  unlimitedFilters: string;
  seeWhoVisitsAndLikesYou: string;
  getPremiumSearchBoost: string;
  continue: string;
};

const messages: I18n<Message> = {
  en: {
    beginYourJourney: 'Begin your journey at MeetMyAge!',
    welcome: 'Welcome, {name}!',
    continuePerWeek: 'Try 7-days trial for {price}',
    meetNewNicePeopleOnline:
      'Meet new nice people online, make friends and spend quality time together. This is what you need to know right now about our platform...',
    next: 'Next',
    free: 'Free',
    rightNowYouAreOn: 'Right now you are on',
    freeSubscription: 'free subscription',
    trial: 'Trial',
    premium: 'With Premium',
    seeBasicProfilesOfOtherSingles: 'See basic profiles of other singles',
    titleFreeSubscription: 'Free subscription',
    limitedChatting: 'Limited chatting',
    limitedLikes: 'Limited likes',
    seeFullProfilesOfOtherSingles: 'See full profiles of other singles',
    unlimitedChatting: 'Unlimited chatting',
    unlimitedLikes: 'Unlimited likes',
    unlimitedFilters: 'Unlimited filters',
    seeWhoVisitsAndLikesYou: 'See who visits and likes you',
    getPremiumSearchBoost: 'Get Premium search boost',
    continue: 'Continue',
  },
  es: {
    beginYourJourney: '¡Comienza tu viaje en MeetMyAge!',
    welcome: '¡Bienvenido, {name}!',
    continuePerWeek: 'Prueba de 7 días por {price}',
    meetNewNicePeopleOnline:
      'Conoce gente agradable en línea, haz amigos y pasa un tiempo de calidad juntos. Esto es lo que necesitas saber ahora sobre nuestra plataforma...',
    next: 'Siguiente',
    free: 'Gratis',
    rightNowYouAreOn: 'Ahora mismo estás en',
    freeSubscription: 'suscripción gratuita',
    trial: 'Prueba',
    premium: 'Con Premium',
    seeBasicProfilesOfOtherSingles: 'Ver perfiles básicos de otros solteros',
    titleFreeSubscription: 'Suscripción gratuita',
    limitedChatting: 'Chats limitados',
    limitedLikes: 'Me gusta limitados',
    seeFullProfilesOfOtherSingles: 'Ver perfiles completos de otros solteros',
    unlimitedChatting: 'Chats ilimitados',
    unlimitedLikes: 'Me gusta ilimitados',
    unlimitedFilters: 'Filtros ilimitados',
    seeWhoVisitsAndLikesYou: 'Ver quién te visita y le gustas',
    getPremiumSearchBoost: 'Obtén un impulso de búsqueda Premium',
    continue: 'Continuar',
  },
  de: {
    beginYourJourney: 'Beginnen Sie Ihre Reise bei MeetMyAge!',
    welcome: 'Willkommen, {name}!',
    continuePerWeek: 'Probieren Sie die 7-Tage-Testversion für {price}',
    meetNewNicePeopleOnline:
      'Treffen Sie neue nette Leute online, schließen Sie Freundschaften und verbringen Sie gemeinsam eine qualitativ hochwertige Zeit. Das müssen Sie jetzt über unsere Plattform wissen...',
    next: 'Weiter',
    free: 'Kostenlos',
    rightNowYouAreOn: 'Sie sind derzeit auf',
    freeSubscription: 'kostenlose Mitgliedschaft',
    trial: 'Testversion',
    premium: 'Mit Premium',
    seeBasicProfilesOfOtherSingles: 'Sehen Sie grundlegende Profile anderer Singles',
    titleFreeSubscription: 'Kostenloses Abonnement',
    limitedChatting: 'Eingeschränktes Chatten',
    limitedLikes: 'Begrenzte Likes',
    seeFullProfilesOfOtherSingles: 'Sehen Sie vollständige Profile anderer Singles',
    unlimitedChatting: 'Unbegrenztes Chatten',
    unlimitedLikes: 'Unbegrenzte Likes',
    unlimitedFilters: 'Unbegrenzte Filter',
    seeWhoVisitsAndLikesYou: 'Sehen Sie, wer Sie besucht und mag',
    getPremiumSearchBoost: 'Premium-Such-Boost erhalten',
    continue: 'Weiter',
  },
};

export { messages };
